const routes = [
  // Core routes
  {
    path: '/',
    meta: { layout: 'default' },
    component: () => import('@/views/index.vue')
  },
  {
    path: '/sign-on',
    meta: { layout: 'authorize', public: true },
    component: () => import('@/views/sign-on.vue')
  },
  {
    path: '/style',
    meta: { layout: 'default', public: true },
    component: () => import('@/views/style.vue')
  },

  // Company routes
  {
    path: '/companies',
    meta: { layout: 'default' },
    component: () => import('@/views/companies/index.vue')
  },
  {
    path: '/companies/add',
    meta: { layout: 'default' },
    component: () => import('@/views/companies/add.vue')
  },
  {
    path: '/companies/:company',
    meta: { layout: 'default' },
    component: () => import('@/views/companies/edit.vue')
  },

  // Project routes
  {
    path: '/projects',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/index.vue')
  },
  {
    path: '/projects/add',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/add.vue')
  },
  {
    path: '/projects/:id',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/view.vue')
  },
  {
    path: '/projects/:id/scores',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/scores.vue')
  },
  {
    path: '/projects/:id/collect',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/collect.vue')
  },

  {
    path: '/projects/:id/insights',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/insights.vue')
  },
  {
    path: '/projects/:id/graphs',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/graphs.vue')
  },
  {
    path: '/projects/:id/story',
    meta: { layout: 'default' },
    component: () => import('@/views/story/view.vue')
  },
  {
    path: '/projects/:id/edit',
    meta: { layout: 'default' },
    component: () => import('@/views/projects/edit.vue')
  },

  // Participant routes
  {
    path: '/participants',
    meta: { layout: 'default' },
    component: () => import('@/views/participants/index.vue')
  },

  {
    path: '/participants/:user',
    component: () => import('@/views/participants/edit.vue'),
    meta: { layout: 'default' }
  },
  {
    path: '/participants/:user/sign-up',
    meta: { layout: 'authorize' },
    component: () => import('@/views/participants/new.vue')
  },
  {
    path: '/participants/:user/projects/:project',
    meta: { layout: 'default' },
    component: () => import('@/views/story/view.vue')
  },
  {
    path: '/participants/:user/projects/:project/journey',
    meta: { layout: 'default' },
    component: () => import('@/views/story/journey.vue')
  },

  {
    path: '/:slug',
    meta: { layout: 'authorize', public: true },
    component: () => import('@/views/projects/slug.vue')
  }
]

export default routes
